import { Functions, getFunctions as createFunctions } from "firebase/functions";
import { getApp } from "firebase/app";

const getFunctions = (): Functions => {
    const app = getApp();
    return createFunctions(app, "europe-west1");
};

export default getFunctions;
